import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper-background-admin"
}
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "wrapper__name" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "wrapper__exit-btn__text" }, "на страницу тестов", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "wrapper__exit-btn__text" }, "на страницу администратора", -1)

import router from "@/router";
import { useAuthStore } from "@/store/AuthModule";
import { useMainStore } from "@/store";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const authStore = useAuthStore();
const mainStore = useMainStore();

const adminName = computed(() => {
  return authStore.name;
});

const doubleRoles = computed(() => {
  return authStore.roles.admin && authStore.roles.user;
});

function goToUserPage() {
  router.push({ name: "user" });
}

function goToAlternativePage() {
  if (router.currentRoute.value.name === "admin") {
    router.push({ name: "user" });
  } else if (router.currentRoute.value.name === "user") {
    router.push({ name: "admin" });
  } else {
    mainStore.setModalParameters({
      title: "Вы уверены?",
      message:
        "Вы уверены, что хотите уйти с этой страницы? Все неотправленные данные будут утеряны!",
      state: true,
      action: "goToAdminPage",
    });
  }
}

function logout() {
  mainStore.setModalParameters({
    title: "Вы уверены?",
    message:
      "Вы уверены, что хотите выйти? Все неотправленные данные будут утеряны!",
    state: true,
    action: "logout",
  });
}

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$route.name === 'admin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(adminName.value), 1),
      _createElementVNode("div", null, [
        (doubleRoles.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "wrapper__exit-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (goToAlternativePage()))
            }, [
              _createTextVNode(" Перейти "),
              (_unref(router).currentRoute.value.name === 'admin')
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_q_icon, {
                      class: "wrapper__exit-btn__icon",
                      name: "list_alt"
                    })
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_q_icon, {
                      class: "wrapper__exit-btn__icon",
                      name: "admin_panel_settings"
                    })
                  ]))
            ]))
          : _createCommentVNode("", true),
        (
          _unref(router).currentRoute.value.name === 'test' ||
          _unref(router).currentRoute.value.name === 'start'
        )
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "wrapper__exit-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToUserPage()))
            }, " Перейти к выбору теста "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "wrapper__exit-btn",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (logout()))
        }, "Выйти")
      ])
    ])
  ], 64))
}
}

})